module.exports = __webpack_public_path__ + "static/img/休眠.1b56fe6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/车辆/汽车吊/休眠.png
// module id = 3w53
// module chunks = 76